<fe-header style="z-index: 1000"></fe-header>
<main class="mb-26 mb-sm-20" *ngIf="hasCart">
    <fe-progress-bar
        [status]="'total'"
        *ngIf="!breakpoint.isMobile()"
        class="d-none d-md-block"
        #progressBarDesktop
    ></fe-progress-bar>
    <fe-progress-bar-mobile
        *ngIf="breakpoint.isMobile()"
        [statusProgress]="'total'"
        class="d-block d-md-none"
    ></fe-progress-bar-mobile>
    <fe-review-reserve
        [marginTop]="progressBarDesktop?.martinTopContainer || 0"
        [formPersonalInfo]="formPersonalInfo"
        [checkBoxs]="checkBoxs"
        [loadingBtnReservate]="loadingBtnReservate"
        [formBBVA]="formBBVA"
        [urlActionBBVA]="urlActionBBVA || ''"
        [successUrl]="successUrl"
        [errorUrl]="errorUrl"
        (reservateClick)="onClicReservate()"
        (onlyLettersKeypress)="onlyLetters($event)"
    ></fe-review-reserve>
    <form #formBBVAelement method="post" [action]="this.urlActionBBVA">
        <input
            type="hidden"
            name="mp_product"
            [value]="formBBVA?.mp_product"
            id="mp_product"
        />
        <input
            type="hidden"
            name="mp_reference"
            [value]="formBBVA?.mp_reference"
            id="mp_reference"
        />
        <input
            type="hidden"
            name="mp_amount"
            [value]="formBBVA?.mp_amount"
            id="mp_amount"
        />
        <input
            type="hidden"
            name="mp_account"
            [value]="formBBVA?.mp_account"
            id="mp_account"
        />
        <input
            type="hidden"
            name="mp_node"
            [value]="formBBVA?.mp_node"
            id="mp_node"
        />
        <input
            type="hidden"
            name="mp_signature"
            [value]="formBBVA?.mp_signature"
            id="mp_signature"
        />
        <input
            type="hidden"
            name="mp_urlsuccess"
            [value]="formBBVA?.mp_urlsuccess"
            id="mp_urlsuccess"
        />
        <input
            type="hidden"
            name="mp_urlsuccess_redirect"
            [value]="successUrl"
            id="mp_urlsuccess_redirect"
        />
        <input
            type="hidden"
            name="mp_urlfailure"
            [value]="formBBVA?.mp_urlfailure"
            id="mp_urlfailure"
        />
        <input
            type="hidden"
            name="mp_urlfailure_redirect"
            [value]="errorUrl"
            id="mp_urlfailure_redirect"
        />
        <input
            type="hidden"
            name="mp_reservation"
            [value]="formBBVA?.mp_reservation"
            id="mp_reservation"
        />
        <input
            type="hidden"
            name="mp_order"
            [value]="formBBVA?.mp_order"
            id="mp_order"
        />
        <input
            type="hidden"
            name="mp_concept"
            [value]="formBBVA?.mp_concept"
            id="mp_concept"
        />
        <input
            type="hidden"
            name="mp_currency"
            [value]="formBBVA?.mp_currency"
            id="mp_currency"
        />
        <input
            type="hidden"
            name="mp_email"
            [value]="formPersonalInfo.get('email')?.value"
            id="mp_email"
        />
        <input
            type="hidden"
            name="mp_phone"
            [value]="formPersonalInfo.get('phone')?.value"
            id="mp_phone"
        />
    </form>
    <fe-car-rental-policy
        [crpInternational]="crpInternational"
    ></fe-car-rental-policy>
</main>
<fe-footer></fe-footer>
